<template>
  <AppHero
    :title="configData.Title"
    :title-is-h1="configData.TitleIsH1"
    :title-extra="configData.TitleExtra"
    :title-extension="configData.TitleExtension"
    :text="configData.Text"
    :text-light="configData.TextLight"
    :link-button-text="configData.LinkButtonText"
    :link-button-url="configData.LinkButtonUrl"
    :image-url="configData.ImageUrl"
    :image-alt="configData.ImageAlt"
    :label-text="configData.LabelText"
    :label-color="configData.LabelColor"
    :layout-row="false"
    :usp-items="configData.UspItems"
  />
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Title?: string;
    TitleIsH1?: boolean;
    TitleExtra?: string;
    TitleExtension?: string;
    Text?: string;
    TextLight?: string;
    LinkButtonText?: string;
    LinkButtonUrl?: string;
    ImageUrl?: string;
    ImageAlt?: string;
    LabelText?: string;
    LabelColor?: string;
    FullBackground: boolean;
    UspItems?: {
      Icon: string;
      Label: string;
      SubLabel?: string;
    }[];
  };
}

defineProps<Props>();
</script>

<style scoped></style>
